import { isMobile } from './isMobile';

export const isSafari = () => {
    const { userAgent } = navigator;
    return /version\/(\d+)((?!chrome).)+?safari/i.test(userAgent);
};

export const isMobileSafari = () => isMobile() && isSafari();
